export default __webpack_public_path__ + "b912cf1bdb62f19c7788e8792dde9f70.webp";